<div class="layout">
    <div class="layout-50 layout-left layout-flex">
        <app-sidebar-message></app-sidebar-message>
    </div>
    <div class="layout-50 layout-right layout-middle">
        <h1>{{ 'auth.login.heading.sso' | translate }}</h1>

        <div class="narrow">
            <div class="alert alert-error" *ngIf="error">
                {{ 'auth.login.form.error' | translate }}
            </div>

            <app-auth-sso-form #form [model]="model" (submit)="onFormSubmitted(form)"></app-auth-sso-form>
        </div>
    </div>
</div>
